/**
 * Created by Reda on 21.10.2025
 */

const Unmovable = function (unit) {
    UnitComponent.call(this, unit);
};

Unmovable.prototype = Object.create(UnitComponent.prototype);
Unmovable.prototype.constructor = Unmovable;

Unmovable.prototype.isMovable = function () {
    return false;
};